<template>
  <div class="slide-page" style="display: flex; flex-flow: column">
    <!-- logo -->
    <!-- <div
      class="top ani animated"
      s-a-effect="fadeInUp"
      s-a-duration="1s"
      s-a-delay="0.2s"
      s-a-style-cache=" "
      style="
        visibility: visible;
        animation-name: fadeInUp;
        -webkit-animation-name: fadeInUp;
        animation-duration: 1s;
        -webkit-animation-duration: 1s;
        animation-delay: 0.2s;
        -webkit-animation-delay: 0.2s;
        text-align: left;
      "
    >
      <img class="logo" src="../../assets/img/logo.png" alt="" />
    </div> -->
    <div style="flex: 1">
      <!-- 首页标题 -->
      <div
        class="ani animated"
        s-a-effect="fadeInUp"
        s-a-duration="1s"
        s-a-delay="0.8s"
        s-a-style-cache=" "
        style="
          visibility: visible;
          animation-name: fadeInUp;
          -webkit-animation-name: fadeInUp;
          animation-duration: 1s;
          -webkit-animation-duration: 1s;
          animation-delay: 0.8s;
          -webkit-animation-delay: 0.8s;
          margin-top: 1.5rem;
        "
      >
        <img
          style="width: 8rem; height: 3.4rem"
          src="../../assets/img/app/app-start/app-start.png"
          alt=""
        />
      </div>
      <ul
        class="navBox ani animated"
        s-a-effect="fadeInUp"
        s-a-duration="1s"
        s-a-delay="1s"
        s-a-style-cache=" "
        style="
          visibility: visible;
          animation-name: fadeInUp;
          -webkit-animation-name: fadeInUp;
          animation-duration: 1s;
          -webkit-animation-duration: 1s;
          animation-delay: 1s;
          -webkit-animation-delay: 1s;
        "
      >
        <li @click="jump(1)">@Rihao</li>
        <li @click="jump(2)">晋升通道</li>
        <li @click="jump(3)">薪酬福利</li>
        <li @click="jump(4)">热招岗位</li>
        <li @click="jump(5)">校招流程</li>
        <li @click="jump(6)">联系我们</li>
      </ul>
    </div>

    <FooterM></FooterM>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import NestedScroll from "@better-scroll/nested-scroll";
import FooterM from "../../components/FooterM.vue";
BScroll.use(NestedScroll);
export default {
  components: {
    FooterM,
  },
  data() {
    return {};
  },
  mounted() {
    new BScroll(this.$refs.content, {
      scrollY: true,
      scrollX: false,
      bounce: false,
      probeType: 3,
      click: true,
      nestedScroll: {
        groupId: "asdf",
      },
    });
  },
  methods: {
    jump(i) {
      this.$emit("jump", i);
    },
  },
};
</script>

<style lang="less" scoped>
.navBox {
  font-size: 0.25rem;
  color: #fff;
  font-weight: 900;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  li {
    // background: url("http://campus.51job.com/growatt2022/mobile/images/nav.png");
    background-size: 100% 100%;
    width: 3.8rem;
    height: 1.6rem;
    line-height: 1.6rem;
    // padding: 0.2rem 0;
    margin: 0.2rem 0.2rem;
    text-align: center;
  }
  li:nth-child(1) {
    background-image: url("../../assets/img/btn-1.png");
  }
  li:nth-child(2) {
    background-image: url("../../assets/img/btn-2.png");
  }
  li:nth-child(3) {
    background-image: url("../../assets/img/btn-3.png");
  }
  li:nth-child(4) {
    background-image: url("../../assets/img/btn-4.png");
  }
  li:nth-child(5) {
    background-image: url("../../assets/img/btn-5.png");
  }
  li:nth-child(6) {
    background-image: url("../../assets/img/btn-6.png");
  }
}
.logo {
  // position: absolute;
  margin: 0.2rem;
  width: 3.5rem;
  padding-left: 0.5rem;
}
</style>
